import { useStaticQuery, graphql } from "gatsby"

const storyblokParseContent = (data) => data.edges
  .map(({node}) => {
    const content = JSON.parse(node.content)
    return { ...content, createdAt: node.created_at, uuid: node.uuid }
  })

const getUniqueSorted = (data, key) => {
  return [...new Set(
    data.map((i) => i[key]).flat().filter(Boolean)
  )].sort()
}

const useCreativeDesigns = () => {
  const data = useStaticQuery(graphql`
    query CreativeCommunityDesignQuery {
      creativeCommunityDesigns: allStoryblokEntry(
        filter: {field_component: {eq: "creativeCommunityDesign"}}
      ) {
        edges {
          node {
            created_at
            uuid
            content
          }
        }
      }

      eventsHubEventPartnerProfiles: allStoryblokEntry(
        filter: {field_component: {eq: "eventsHubEventPartnerProfile"}, field_partnerType_string: {eq: "Creative Community"}}
      ) {
        edges {
          node {
            created_at
            uuid
            content
          }
        }
      }
    }
  `);

  const creativeCommunityDesigns = storyblokParseContent(data.creativeCommunityDesigns)
  const profiles = storyblokParseContent(data.eventsHubEventPartnerProfiles)

  const creativeDesignsWithDesignerProfile = creativeCommunityDesigns.map(
    ({
      designTitle, createdAt, productType, designsFiles,
      designType, designStyle, designer, designerProfile
    }) => ({
      designTitle, createdAt, productType,
      designsFiles: designsFiles?.map((f) => ({
        file: { url: f.filename }
      })),
      designType, designStyle, designer, designerProfile
    })
  )

  const creativeDesigns = creativeDesignsWithDesignerProfile.map((d) => {
    const profile = profiles.find((p) => p.designerProfile === d.designerProfile)
  
    return {
      ...d,
      designerProfile: {
        partnerLogo: {
          file: { url: profile?.partnerLogo.filename },
          title: profile?.partnerLogo.title
        },
        partnerName: profile?.partnerName,
        partnerCountry: profile?.partnerCountry
      }
    }
  }).filter(Boolean)

  return {
    creativeProductTypes: {
      distinct: getUniqueSorted(creativeCommunityDesigns, 'productType')
    },
    creativeDesignStyle: {
      distinct: getUniqueSorted(creativeCommunityDesigns, 'designStyle')
    },
    creativeDesignTemplateType: {
      distinct: getUniqueSorted(creativeCommunityDesigns, 'designType')
    },
    creativeDesigns
  }
}

export default useCreativeDesigns;
